import React from 'react'
import { useTheme as useKittenTheme } from '@ui-kitten/components'
import { ThemeContext } from '../theme'

export function useTheme() {
  const kittenTheme = useKittenTheme()
  const { theme, toggleTheme } = React.useContext(ThemeContext)
  return { theme, toggleTheme, ...kittenTheme }
}
